import styled from 'styled-components';
import Form from 'react-bootstrap/Form';
import { HOVER_ITEM_COLOR, PRIMARY, BACKGROUND_COLOR } from '../../utils/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  font-family: 'Figtree', sans-serif;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`

export const QuotationFormWrapper = styled.div`
  width: 70%;

  @media (max-width: 800px) {
    width: 100%;
  }
`

export const ProductListWrapper = styled.div`
  width: 30%;
  margin-top: 90px;
  padding: 3rem;
  background-color: ${BACKGROUND_COLOR};
  max-height: 100vh;
  overflow-y: auto;

  @media (max-width: 800px) {
    width: 100%;
  }
`
export const QuotationForm = styled.div`
  padding: 3rem;
  margin-top: 90px;
`

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
  font-family: 'FigtreeBold', sans-serif;
`;

export const SmallTitle = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  font-family: 'FigtreeBold', sans-serif;
`;

export const FormWrapper = styled(Form)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  padding: 2rem;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

export const RequestQuotationButton = styled.button`
  background-color: ${PRIMARY};
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-family: 'FigtreeBold', sans-serif;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: background-color 0.3s ease;
  justify-content: center;

  &:hover {
    background-color: ${HOVER_ITEM_COLOR};
  }
`;

export const ProductImage = styled.img`
  width: 100%;
  max-width: 200px;
  height: auto;

  @media (max-width: 1300px) {
    max-width: 150px;
  }

  @media (max-width: 1200px) {
    max-width: 100px;
  }

  @media (max-width: 800px) {
    max-width: 150px;
  }
`;

export const QuotationCardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  gap: 4px;
  padding: 1rem;
  @media (max-width: 1300px) {
    padding: 0 1rem;
  }

  @media (max-width: 1200px) {
    padding: 0 0.5rem;
  }

  @media (max-width: 800px) {
    gap: 0;
  }
`;